































import Vue from 'vue';

import {Component} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import {FamilySegment, tabs} from '../../../models';
import {ActionTypes, GetterTypes} from '@/modules/neovehicle/store/types';
import FastSearch from '@/modules/neovehicle/components/fast-search-model.component.vue';

@Component({
  components: {
    FastSearch,
  },
})
export default class extends Vue {
  public tabs = tabs;

  @Getter(GetterTypes.GET_CURRENT_TAB)
  public currentTab: string;

  @Getter(GetterTypes.GET_FAMILY_SEGMENT_SELECTED)
  public familySegmentSelected: FamilySegment | null;

  @Action(ActionTypes.CLEAR_STORE)
  private clearStore: () => void;

  public destroyed() {
    this.clearStore();
  }
}
